import type { TFunction } from "i18next";
import { ApiError, getLocalUserFacingApiMessage, getUserFacingApiMessage } from "@/lib/api-client";

// Without a formatter api-client always returns generic copy. Only the create dialogs opt in: their
// 4xx replies (duplicate name, invalid name) are actionable, unlike generate/retry failures.
const passThroughApiMessage = (message: string) => message;

export const OPPORTUNITY_TYPE_DISABLED_CODE = "OPPORTUNITY_TYPE_DISABLED";

export function isOpportunityTypeDisabledError(error: unknown): boolean {
  return error instanceof ApiError && error.code === OPPORTUNITY_TYPE_DISABLED_CODE;
}

export function opportunityTypeDisabledMessage(t: TFunction): string {
  return t(
    "personaOpportunities.toast.opportunityTypeDisabled",
    "This opportunity type is turned off for your organization. Refresh the page or ask an admin to re-enable it.",
  );
}

/** Inline copy in create-set dialogs (mutation `error` state). */
export function personaOpportunityGenerationInlineError(error: unknown, t: TFunction): string | null {
  if (isOpportunityTypeDisabledError(error)) {
    return opportunityTypeDisabledMessage(t);
  }
  return getUserFacingApiMessage(error, passThroughApiMessage);
}

/** Toast copy for persona-opportunity-set generation mutations (`skipGlobalError` hooks). */
export function personaOpportunityGenerationToastMessage(error: unknown, t: TFunction): string | null {
  if (isOpportunityTypeDisabledError(error)) {
    return opportunityTypeDisabledMessage(t);
  }
  return getLocalUserFacingApiMessage(error);
}
